import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig, AuthProvider } from './auth';
import { AppProvider } from './context/AppContext';
import { ThemeProvider } from './context/ThemeContext';
import { NavigationProvider } from './context/NavigationContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { logUnhandledError } from './utils/logger';
import { reportError } from './utils/errorReporting';
import AppRouter from './AppRouter';
import '@fontsource-variable/inter';
import './index.css';

// Unhandled Promise Rejections abfangen
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason instanceof Error
    ? event.reason
    : new Error(String(event.reason));

  logUnhandledError(error, { action: 'unhandledrejection' });
  reportError(error, 'unhandledrejection');
});

// Globale Fehler abfangen (die nicht von ErrorBoundary gefangen werden)
window.addEventListener('error', (event) => {
  // Nur JS-Fehler, keine Resource-Load-Fehler
  if (event.error) {
    logUnhandledError(event.error, { action: 'window.onerror' });
    reportError(event.error, 'window.onerror');
  }
});

// MSAL-Instanz erstellen
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <AppProvider>
              <NavigationProvider>
                <AppRouter />
              </NavigationProvider>
            </AppProvider>
          </AuthProvider>
        </MsalProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
